import { createAuthFetch } from "../utils/authFetch";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import {
  useTable,
  usePagination,
  useSortBy,
} from "react-table";
import {
  formatImage,
  formatStatus,
  formatActions,
  formatProdInfo
} from "./Formatters";
import {
  Table,
  Button,
  Spinner,
  Form,
} from "react-bootstrap";
import {
  ChevronDown,
  ChevronUp,
  ArrowDownUp,
} from "react-bootstrap-icons";
import { useFilters } from "../context/GlobalFilterContext";
import ListingMobileCard from "./ListingMobileCard";
import { normalizeAccount } from "../utils/normalizeAccount";

function ListingTable({ filters }) {

  const navigate = useNavigate();
  const authFetch = createAuthFetch(navigate);

  const { account, marketplace } = useFilters();

  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  const [columnFilters, setColumnFilters] = useState({});

  const columns = useMemo(
    () => [
      {
        Header: "Actions",
         id: "actions",
         Cell: ({ row }) => formatActions(row.original),
         disableSortBy: true,
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => formatStatus(value),
        id: "status",
        search: true
      },
      {
        Header: "Image",
        accessor: "img",
        disableSortBy: true,
        Cell: ({ value }) => formatImage(value),
        id: "img"
      },
      {
        Header: "Title",
        accessor: "title",
        id: "title"
      },
      {
        Header: "ASIN/SKU/FNSKU",
        accessor: "asin",
        id: "asin",
        Cell: ({ row }) => formatProdInfo(row.original)
      },
      {
        Header: "Price",
        accessor: "price",
        id: "price"
      },
      {
        Header: "FBA Fee",
        accessor: "fee",
        id: "fee"
      },
      {
        Header: "Sales",
        accessor: "sales",
        id:"sales"
      },
      {
        Header: "Sessions",
        accessor: "sessions",
        id: "sessions"
      },
      {
        Header: "Stock",
        accessor: "stock",
        id: "stock"
      },
      {
        Header: "Inbound",
        accessor: "inbound",
        id: "inbound"
      },
    ],
    []
  );

  const {
    getTableProps,
     getTableBodyProps,
     headerGroups,
     page,
     prepareRow,
     gotoPage,
     state: tableState,
     setPageSize
  } = useTable(
    {
      columns,
      data,
      manualPagination: true,
      manualSortBy: true,
      pageCount: Math.ceil(totalRows / 50),
      initialState: {
        pageIndex: 0,
        sortBy: [{ id: "sales", desc: true }],
        pageSize: 25
      },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    if (!account || !marketplace || !filters?.dateFrom || !filters?.dateTo) return;

    const fetchData = async () => {
      setLoading(true);
      const normalizedAccount = normalizeAccount(account);
      const body = {
          account:normalizedAccount,
          marketplace,
          sidx: tableState.sortBy[0]?.id || "sales",
          sord: tableState.sortBy[0]?.desc ? "desc" : "asc",
          rows: tableState.pageSize.toString(),
          page: (tableState.pageIndex + 1).toString(),
          search: filters.search || null,
          start: filters.dateFrom,
          end: filters.dateTo,
          type: filters.type || null,
          sort: filters.sort || null,
        };

      const res = await authFetch(`/amz-api/products/views/listings`, {
        method: "POST",
        body: JSON.stringify(body),
      });
      if (!res) return;

      const result = await res.json();
      setData(result.rows || []);
      setTotalRows(result.total || 0);

      setLoading(false);
    };

    fetchData();
    }, [account, marketplace, tableState.pageIndex, tableState.pageSize, tableState.sortBy, columnFilters, filters]);

  if (!filters?.dateFrom || !filters?.dateTo) return null;

  return (
    <>
    <div className="d-none d-md-block view">
      <Table striped bordered hover responsive size="sm" {...getTableProps()}>
        <thead>
                {headerGroups.map((headerGroup) => {
                  const headerGroupProps = headerGroup.getHeaderGroupProps();
                  const { key: headerGroupKey, ...headerGroupRest } = headerGroupProps;

                  return (
                    <tr key={headerGroupKey} {...headerGroupRest}>
                      {headerGroup.headers.map((column) => {
                        const headerProps = column.getHeaderProps(
                          column.getSortByToggleProps()
                        );
                        const { key: columnKey, ...columnRest } = headerProps;

                        return (
                          <th
                            key={columnKey}
                            {...columnRest}
                            className={
                              column.isSorted
                                ? column.isSortedDesc
                                  ? "sortby active desc"
                                  : "sortby active asc"
                                : "sortby"
                            }
                          >
                            {column.render("Header")}
                            {column.isSorted ? (<i className={`fa-solid fa-arrow-${column.isSortedDesc ? "down" : "up"}`}></i>) : ""}

                          </th>
                        );
                      })}
                    </tr>
                  );
                })}

               {/* Фільтри */}
               <tr>
                 {columns.map(col => {
                   const key = typeof col.accessor === "string" ? col.accessor : col.id || col.Header;
                   return (
                     <th key={`filter-${key}`}>
                       {key && col.search ? (
                        col.accessor=='status' ? (
                          <div>
                         <Form.Select
                           size="sm"
                           value={columnFilters[key] || ""}
                           onChange={(e) => {
                             setColumnFilters(prev => ({
                               ...prev,
                               [key]: e.target.value,
                             }));
                             gotoPage(0);
                           }}
                           style={{ width: "auto", display: "inline-block" }}
                         >
                           {['all','active','hijacker','inactive','incomplete','removed','search suppressed','unchangeable'].map((status) => (
                             <option key={status} value={status}>
                               {status}
                             </option>
                           ))}
                         </Form.Select>
                         </div>)
                        :
                         (<Form.Control
                           size="sm"
                           type="text"
                           placeholder="Filter"
                           value={columnFilters[key] || ""}
                           onChange={(e) => {
                             setColumnFilters(prev => ({
                               ...prev,
                               [key]: e.target.value,
                             }));
                             gotoPage(0);
                           }}
                         />)
                       ) : null}
                     </th>
                   );
                 })}
               </tr>
             </thead>

        <tbody {...getTableBodyProps()}>
          {loading ? (
            <tr>
              <td colSpan={columns.length}>
                <div className="p-5 my-4"><Spinner animation="grow" variant="secondary" size="sm"/><span className="visually-hidden">Loading...</span></div>
              </td>
            </tr>
          ) : page.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center text-muted">
                No data
              </td>
            </tr>
          ) : (
            page.map((row) => {
              prepareRow(row);

              const rowProps = row.getRowProps();
              const { key: rowKey, ...rowRest } = rowProps;

              return (
                  <tr key={rowKey} {...rowRest}>
                    {row.cells.map((cell) => {
                      const cellProps = cell.getCellProps();
                      const { key: cellKey, ...cellRest } = cellProps;
                      const colClass =
                      typeof cell.column.id === "string" ? `${cell.column.id}` : "";
                      //console.log(cellProps) ;
                      return (
                            <td key={cellKey} {...cellRest} className={`${cellRest.className || ""} ${colClass}`.trim()}>
                              {cell.render("Cell")}
                            </td>
                          );
                        })}
                      </tr>
                    );
            })
          )}
        </tbody>
      </Table>
      </div>

      <div className="d-block d-md-none view">
        {loading ? (
             <div className="p-5 my-4"><Spinner animation="grow" variant="secondary" size="sm"/><span className="visually-hidden">Loading...</span></div>
         ) : page.length === 0 ? (
           <div className="text-center text-muted py-4">
             No data
           </div>
         ) : (
           page.map(row => (
             <ListingMobileCard
               key={row.original.id || row.original.asin}
               item={row.original}
             />
           ))
         )}
      </div>

      <div className="pager d-flex justify-content-center align-items-center gap-2">
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => gotoPage(tableState.pageIndex - 1)}
          disabled={tableState.pageIndex === 0}
        >
          Prev
        </Button>
        <span>
          Page <strong>{tableState.pageIndex + 1}</strong>
        </span>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => gotoPage(tableState.pageIndex + 1)}
          disabled={(tableState.pageIndex + 1) * tableState.pageSize >= totalRows}
        >
          Next
        </Button>
        <div>
            <Form.Select
              size="sm"
              value={tableState.pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                //setPageIndex(0); // скидати на першу сторінку
                gotoPage(0);
                //gotoPage(1);
              }}
              style={{ width: "auto", display: "inline-block" }}
            >
              {[25, 50, 100].map((size) => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </Form.Select>
          </div>
          <div className="text-muted small">
            Showing {tableState.pageIndex * tableState.pageSize + 1}–{Math.min((tableState.pageIndex + 1) * tableState.pageSize, totalRows)} of {totalRows}
          </div>
      </div>
    </>
  );
}

export default ListingTable;
